<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      :show-save-button="$permission.canEdit()"
      unit="国家信息"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="95px"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      :get-data-func="api.info"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="国家名称" prop="CountryName">
              <el-input
                v-model="data.CountryName"
                placeholder="请填写国家名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
           <el-col :span="isMB ? 24 : 12">
            <el-form-item label="国家编码" prop="CountryCode">
              <el-input
                v-model="data.CountryCode"
                placeholder="请填写国家编码"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="国旗" prop="CountryFlag">
              <single-pic-upload
                v-model="data.CountryFlag"
                type="CountryFlag"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
            </el-form-item>
          </el-col>
        </el-row>
       
       
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";


export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
  
  },
  data() {
    return {
      data: {
        RecordId: 0,

        CountryName: "",
        CountryCode: "",
        CountryFlag: "",
      
      },

      api: require("@/api/sy/country").default,

      isMB: this.$store.state.isMB,
      rules: {
        CountryName: [{ required: true, message: "国家名称不能为空" }],
        CountryCode: [{ required: true, message: "国家编码不能为空" }],

        CountryFlag: [{ required: true, message: "国旗不能为空" }],
      },
      uploadUrl: "/api/Common/UploadPicture",
   //   loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
    };
  },
  methods: {
    onCreateOpened(row) {
     
    },
    onEditOpened(row) {},
    onBeforeSave() {},
    onClosed() {},
  },
};
</script>